// api/axiosConfig.js
import axios from 'axios';

// ONLY ONE URL - NO LOCALHOST
const BASE_URL = 'https://travskyapi.softscooptechnologies.com';

// Create axios instance with base configuration
const API = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

// Request interceptor - Add token to every outgoing request
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    // Debug: Check what URL is being called
    console.log(`📤 Calling: ${config.baseURL}${config.url}`);
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle token expiration and errors
API.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // Check if error is due to unauthorized access
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        const refreshToken = localStorage.getItem('refresh_token');
        
        if (refreshToken) {
          // FIXED: Using the SAME URL, no localhost
          const response = await axios.post(`${BASE_URL}/api/refresh-token`, {
            refresh_token: refreshToken
          });
          
          if (response.data.token) {
            localStorage.setItem('token', response.data.token);
            originalRequest.headers['Authorization'] = `Bearer ${response.data.token}`;
            return API(originalRequest);
          }
        }
      } catch (refreshError) {
        console.error('Token refresh failed:', refreshError);
        clearSession();
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    
    if (error.response?.status === 401) {
      clearSession();
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

const clearSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  localStorage.removeItem('nav_list');
  sessionStorage.clear();
};

export default API;